import React, {useEffect, useState} from "react"
import TableData from "./TableData";
import Widget from "../../components/widget";
import {apiGetParkingList} from "./Actions";
import {Form} from "react-final-form";
import ParkingArealField from "../../FinalForm/api/ParkingArealField";
import {FiRefreshCcw} from "react-icons/fi";
import {Button} from "../../components/My/Button";


const ParkingList = () => {

    let [loading, setLoading] = useState(false)
    let [data, setData] = useState(null)


    const validateData = (values) => {
        let errors = {};
        if(!values.parkingArealId){
            errors.parkingArealId = true;
        }

        return errors;
    }

    const getParkingList = (values) => {
        setLoading(true)
        apiGetParkingList(values,(data) => {
            setData(data)
            setLoading(false)
        }, (err) => {
            setLoading(false)
            //console.log(err)
        })
    }

    return (
        <>
            <Widget>
                <div className={"flex flex-row text-black"}>
                    <h5 className={"align-middle"}>Parkování ENIGOO</h5>
                    <span className="ml-auto"></span>
                    <div className={"flex"}>
                    </div>
                </div>
            </Widget>
            <Widget>
            <Form onSubmit={getParkingList} validate={validateData}
                  render={({values, handleSubmit, form}) => {
                      return (
                          <div className={"grid grid-cols-2 lg:grid-cols-4 gap-2"}>
                              <ParkingArealField name={"parkingArealId"} label={"Subjekt"} />
                              {/*<DateTimeField name={"dateFrom"} isMandatory={false} valueToCompare={values?.dateTo}
                                             validateFun={(date1, date2) => {
                                                 if (moment(date1).isAfter(moment(date2))) {
                                                     return "Datum od nemůže být po datu do"
                                                 } else {
                                                     return "";
                                                 }
                                             }} label={"Datum od"} type={"from"} placeholder={"Datum od"}
                                             showTimeSelect={true} onEnter={handleSubmit}/>
                              <DateTimeField name={"dateTo"} isMandatory={false} valueToCompare={values?.dateFrom}
                                             validateFun={(date1, date2) => {
                                                 if (moment(date2).isAfter(moment(date1))) {
                                                     return "Datum od nemůže být po datu do"
                                                 } else {
                                                     return "";
                                                 }
                                             }} label={"Datum do"} type={"to"} placeholder={"Datum do"}
                                             showTimeSelect={true} onEnter={handleSubmit}/>*/}
                              <div className={"lg:col-start-4 mt-6 mb-5 flex justify-end w-full"}>
                              <Button
                                  onClick={() => handleSubmit()} loading={loading} text={"Zobrazit"}
                                  icon={<FiRefreshCcw/>}/>
                              </div>
                          </div>
                      )}}/>
            </Widget>
            <TableData data={data} loading={loading}/>
        </>
    )

}

export default ParkingList
